module.exports = __webpack_public_path__ + "static/img/bg_p07@2x.96e992cb.png";